import { useEffect } from 'react';
import { useMatomo } from "@datapunt/matomo-tracker-react";
import isElectron from 'is-electron'

/*
 *  @Description:   Component that handles analytics events.
 */

const AnalyticsEventHandler = () => {
    const application = isElectron () ? "- Desktop" : "- Web"
    const { pushInstruction, trackEvent, trackSiteSearch, trackPageView, trackLink } = useMatomo ();
    // console.info ( "Analytics Event Handler" );

    useEffect ( () => {
        window.addEventListener ( "triggerSearchAnalytics", activateSearchAnalytics, false );
        window.addEventListener ( "triggerVisitToSearchAnalytics", activateVisitToSearchAnalytics, false );
        window.addEventListener ( "triggerItemAnalytics", activateItemAnalytics, false );
        window.addEventListener ( "triggerLinkAnalytics", activateLinkAnalytics, false );
        window.addEventListener ( "triggerProfileAnalytics", activateProfileAnalytics, false );
        window.addEventListener ( "triggerItemStoreAnalytics", activateItemStoreAnalytics, false );
        window.addEventListener ( "triggerItemDownloadAnalytics", activateItemDownloadAnalytics, false );
        window.addEventListener ( "triggerPDFViewerAnalytics", activatePDFViewerAnalytics, false );
        window.addEventListener ( "triggerStreamViewerAnalytics", activateStreamViewerAnalytics, false );

        return () => {
            window.removeEventListener ( "triggerSearchAnalytics", activateSearchAnalytics, false );
            window.removeEventListener ( "triggerVisitToSearchAnalytics", activateVisitToSearchAnalytics, false );
            window.removeEventListener ( "triggerItemAnalytics", activateItemAnalytics, false );
            window.removeEventListener ( "triggerLinkAnalytics", activateLinkAnalytics, false );
            window.removeEventListener ( "triggerProfileAnalytics", activateProfileAnalytics, false );
            window.removeEventListener ( "triggerItemStoreAnalytics", activateItemStoreAnalytics, false );
            window.removeEventListener ( "triggerItemDownloadAnalytics", activateItemDownloadAnalytics, false );
            window.removeEventListener ( "triggerPDFViewerAnalytics", activatePDFViewerAnalytics, false );
            window.removeEventListener ( "triggerStreamViewerAnalytics", activateStreamViewerAnalytics, false );

        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    const getTrackLink = ( id, index ) => {
        let trackLink = ( isElectron () ? process.env.REACT_APP_SITE_URL : document.location.origin ) + "/link/" + id;

        if ( index !== undefined ) {
            trackLink = ( isElectron () ? process.env.REACT_APP_SITE_URL : document.location.origin ) + "/link/" + id + "/" + index;
        }

        return trackLink
    }

    const activateSearchAnalytics = ( event ) => {
        const { searchString, user } = event.detail;
        const href = isElectron () ? process.env.REACT_APP_SITE_URL + "/search/" + searchString : window.location.href;

        pushInstruction ( 'setUserId', user );
        trackEvent ( {
            category: 'WDOCS ' + application,
            action: 'search',
            name: "Query: " + searchString,
            href
        } );
        trackSiteSearch ( {
            keyword: searchString,
            category: false,
            count: false
        } );

        //pushInstruction ( 'trackEvent', 'WDOCS ' + application, 'search', "Query: " + searchString );
        //pushInstruction ( 'trackSiteSearch', searchString, false, false )
    }

    const activateVisitToSearchAnalytics = ( event ) => {
        const { searchString, user } = event.detail;
        const locationOrigin = isElectron () ? process.env.REACT_APP_SITE_URL : window.location.origin
        const documentURL = decodeURIComponent ( locationOrigin + "/search/" + searchString );

        pushInstruction ( 'setUserId', user );
        trackPageView ( {
            documentTitle: "Search Page - Query: " + searchString,
            href: documentURL
        } )

        // pushInstruction ( "setDocumentTitle", "Search Page - Query: " + searchString );
        // pushInstruction ( 'setCustomUrl', documentURL );
        // pushInstruction ( 'trackPageView' );
    }

    const activateItemAnalytics = ( event ) => {
        const { data, user } = event.detail;
        const { type, id } = data;

        const title = data.name ? data.name : data.title;
        const documentTitle = "View " + type + " " + id + ": " + title;
        const href = getTrackLink ( id );

        pushInstruction ( 'setUserId', user );
        trackEvent ( {
            documentTitle,
            category: 'WDOCS ' + application,
            action: 'visit' + type.toLowerCase (),
            name: data.id + " - " + data.title,
            href
        } );
        trackPageView ( {
            documentTitle,
            href
        } )

        // pushInstruction ( "setDocumentTitle", "View " + type + " " + id + ": " + title );
        // pushInstruction ( 'setCustomUrl', isElectron () ? process.env.REACT_APP_SITE_URL + window.location.pathname : window.location.href );
        // pushInstruction ( 'trackEvent', 'WDOCS ' + application, 'visit' + type.toLowerCase (), data.id + " - " + data.title );
        // pushInstruction ( 'trackPageView' );
    }

    const activateLinkAnalytics = ( event ) => {
        const { data, user } = event.detail;
        const { id, itemIndex, type, title } = data;
        const documentTitle = "View Linked " + type + " " + id + " " + title + " " + ( itemIndex !== undefined ? " - Resource Index: " + itemIndex : "" );

        const href = getTrackLink ( id, itemIndex );

        pushInstruction ( 'setUserId', user );
        trackEvent ( {
            documentTitle,
            category: 'WDOCS - Web',
            action: 'visit link ' + type,
            name: id + " " + title + " " + ( itemIndex !== undefined ? " - Resource Index: " + itemIndex : "" ),
            href
        } );
        trackPageView ( {
            documentTitle,
            href
        } )

        // pushInstruction ( 'setCustomUrl', isElectron () ? process.env.REACT_APP_SITE_URL + window.location.pathname : window.location.href );
        // pushInstruction ( "setDocumentTitle", "View Linked " + data.type + " " + data.id + " " + data.title + " " + ( data.itemIndex !== undefined ? " - Resource Index: " + data.itemIndex : "" ) );
        // pushInstruction ( 'trackEvent', 'WDOCS - Web', 'visit link ' + data.type, data.id + " " + data.title + " " + ( data.itemIndex !== undefined ? " - Resource Index: " + data.itemIndex : "" ) );
        // pushInstruction ( 'trackPageView' );
    }

    const activateProfileAnalytics = ( event ) => {
        const { section } = event.detail;
        const documentTitle = "Profile Page - Section: " + section;
        let href = window.location.href;

        if ( isElectron () ) {
            href = process.env.REACT_APP_SITE_URL + "/profile/" + section.toLowerCase ();
        }

        trackEvent ( {
            documentTitle,
            category: 'WDOCS ' + application,
            action: 'visit',
            name: "Profile Page - Section: " + section,
            href
        } );

        trackPageView ( {
            documentTitle,
            href
        } );


        // pushInstruction ( 'setCustomUrl', isElectron () ? process.env.REACT_APP_SITE_URL + window.location.pathname : window.location.href );
        // pushInstruction ( "setDocumentTitle", "Profile Page - Section: " + section );
        // pushInstruction ( 'trackEvent', 'WDOCS ' + application, 'visit', "Profile Page - Section: " + section );
        // pushInstruction ( 'trackPageView' );
    }

    const activateItemStoreAnalytics = ( event ) => {
        const { data, user } = event.detail;
        const { id, name, type, index } = data;

        pushInstruction ( 'setUserId', user );
        trackEvent ( {
            category: 'WDOCS ' + application,
            action: 'store ' + type,
            name: id + " - " + name,
            href: getTrackLink ( id, index )
        } );
        trackLink ( {
            href: getTrackLink ( id, index ),
            linkType: 'download'
        } );

        // pushInstruction ( 'trackEvent', 'WDOCS ' + application, 'store ' + type, id + " - " + name );
        // pushInstruction ( 'trackLink', trackLink, 'download' );
    }

    const activateItemDownloadAnalytics = ( event ) => {
        const { data, user } = event.detail;
        const { id, name, index } = data;

        pushInstruction ( 'setUserId', user );
        trackEvent ( {
            category: 'WDOCS ' + application,
            action: 'download file',
            name: id + " - " + name,
            href: getTrackLink ( id, index )
        } );
        trackLink ( {
            href: getTrackLink ( id, index ),
            linkType: 'download'
        } );

        // pushInstruction ( 'trackEvent', 'WDOCS ' + application, 'download file', id + " - " + name );
        // pushInstruction ( 'trackLink', trackLink, 'download' );
    }

    const activatePDFViewerAnalytics = ( event ) => {
        const { data, user } = event.detail;
        const { id, name, itemIndex } = data;

        pushInstruction ( 'setUserId', user );
        trackEvent ( {
            category: 'WDOCS ' + application,
            action: 'view pdf',
            name: id + " - " + name,
            href: getTrackLink ( id, itemIndex )
        } );

        // pushInstruction ( 'trackEvent', 'WDOCS ' + application, 'view pdf', id + " - " + name );
    }

    const activateStreamViewerAnalytics = ( event ) => {
        const { data, user } = event.detail;
        const { id, name, itemIndex } = data;

        pushInstruction ( 'setUserId', user );
        trackEvent ( {
            category: 'WDOCS ' + application,
            action: 'play stream',
            name: id + " - " + name,
            href: getTrackLink ( id, itemIndex )
        } );

        // pushInstruction ( 'trackEvent', 'WDOCS ' + application, 'play stream', id + " - " + name );
    }

    return null
}

export default AnalyticsEventHandler;